import { render, staticRenderFns } from "./CountryAdd.vue?vue&type=template&id=dcb52ed0&scoped=true&"
import script from "./CountryAdd.vue?vue&type=script&lang=js&"
export * from "./CountryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb52ed0",
  null
  
)

export default component.exports